export default __webpack_public_path__ + "static/media/Hammer of the Sanguine Disciple.6acc7149.jpg";